"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Avatar/OrgAvatar.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);


var _BaseAvatar = require('./BaseAvatar'); var _BaseAvatar2 = _interopRequireDefault(_BaseAvatar);





const OrgAvatar = ({ orgKey, ...props }) => (
  _react2.default.createElement(_BaseAvatar2.default, {
    icon: "/assets/icons/avatar/icon-org.svg",
    backgroundColorKey: orgKey,
    ...props, __self: this, __source: {fileName: _jsxFileName, lineNumber: 11}}
  )
)

exports. default = OrgAvatar
